import React, { useState } from "react";
import { useSelectedPlanContext } from "../../../../contexts/SelectedPlanContext";

const DeleteServiceButton = ({ translations }) => {
	const { changeSelectedPlan } = useSelectedPlanContext();
	const [showModal, setShowModal] = useState(false);

	const handleDelete = () => {
		changeSelectedPlan({
			id: "",
			name: "",
			type: "",
			price: 0,
			cpu: { id: "", value: "" },
			cpus: [],
			storage: { id: "", value: "" },
			storages: [],
			ram: { id: "", value: "" },
			rams: [],
			transfer: { id: "", value: "" },
			transfers: [],
			bandwidth: { id: "", value: "" },
			bandwidths: [],
			nas: [],
			racks: [],
			energies: [],
			prefixes: [],
			order: 1,
		});
		setShowModal(false);
	};

	const handleCancel = () => {
		setShowModal(false);
	};

	return (
		<>
			<button
				className="flex items-center justify-center p-2 rounded hover:bg-gray-700 relative"
				onClick={() => setShowModal(true)}
				type="button"
			>
				<svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M1.75 13.9293C1.75 15.2401 2.79469 16.3027 4.08333 16.3027H9.91667C11.2053 16.3027 12.25 15.2401 12.25 13.9293V4.4358H13.4167C13.7388 4.4358 14 4.17016 14 3.84246C14 3.51475 13.7388 3.24911 13.4167 3.24911H10.4475C10.1139 1.31243 8.30007 0.0174509 6.39607 0.356726C4.94392 0.615485 3.80689 1.77204 3.5525 3.24911H0.583333C0.261158 3.24911 0 3.51475 0 3.84246C0 4.17016 0.261158 4.4358 0.583333 4.4358H1.75V13.9293ZM7 1.46907C8.06336 1.4699 8.99167 2.20186 9.2575 3.24911H4.7425C5.00833 2.20186 5.93664 1.4699 7 1.46907ZM4.08333 4.4358H11.0833V13.9293C11.0833 14.5848 10.561 15.116 9.91667 15.116H4.08333C3.43898 15.116 2.91667 14.5848 2.91667 13.9293V4.4358H4.08333ZM4.66667 12.7427V6.80919C4.66667 6.48149 4.92782 6.21584 5.25 6.21584C5.57218 6.21584 5.83333 6.48149 5.83333 6.80919V12.7427C5.83333 13.0704 5.57218 13.336 5.25 13.336C4.92782 13.336 4.66667 13.0704 4.66667 12.7427ZM8.16667 12.7427V6.80919C8.16667 6.48149 8.42782 6.21584 8.75 6.21584C9.07218 6.21584 9.33333 6.48149 9.33333 6.80919V12.7427C9.33333 13.0704 9.07218 13.336 8.75 13.336C8.42782 13.336 8.16667 13.0704 8.16667 12.7427Z"
						fill="#E4E4E7"
					/>
				</svg>
			</button>

			{/* Modal */}
			{showModal && (
				<>
					<div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={handleCancel}></div>
					<div className="absolute left-1/2 transform -translate-x-1/2 top-10 flex z-50 bg-ipxon-dark-gray rounded px-5 py-2.5 shadow-lg">
						<div className=" rounded-lg shadow-lg">
							<div className="flex max-md:flex-wrap max-md:flex-col max-md:items-start gap-4 items-center">
								<span className="text-sm text-ipxon-white whitespace-nowrap">
									{translations["DeleteConfirmationMessage"]}
								</span>

								<div className="flex gap-3">
									<button
										className="text-xs font-bold text-ipxon-white uppercase"
										onClick={handleDelete}
									>
										{translations["DeleteConfirmationButton"]}
									</button>

									<span className="text-ipxon-white text-2xl">|</span>
									<button className="text-ipxon-white" onClick={handleCancel}>
										<svg
											width="24"
											height="22"
											viewBox="0 0 24 22"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<rect width="24" height="22" rx="4" fill="#FAFAFA" />
											<path
												d="M15.6529 14.991L12.4946 11.0001L15.6529 7.00927C15.781 6.84742 15.7362 6.62367 15.5531 6.51046C15.3698 6.39723 15.1167 6.43697 14.9886 6.5987L12 10.3751L9.01133 6.5987C8.94931 6.52029 8.85642 6.46795 8.74976 6.4513C8.64325 6.43482 8.53562 6.45562 8.44687 6.51047C8.26372 6.62367 8.21893 6.84742 8.34702 7.00927L11.5054 11.0001L8.34702 14.991C8.28496 15.0693 8.26117 15.1644 8.28006 15.2585C8.29891 15.3527 8.35818 15.4348 8.44687 15.4896C8.51535 15.532 8.59557 15.5544 8.67889 15.5544C8.81119 15.5544 8.93547 15.4972 9.01133 15.4014L12 11.625L14.9886 15.4014C15.0644 15.4972 15.1887 15.5544 15.3211 15.5544C15.4044 15.5544 15.4846 15.532 15.5531 15.4897C15.6418 15.4348 15.7011 15.3527 15.7199 15.2585C15.7388 15.1644 15.715 15.0693 15.6529 14.991Z"
												fill="#18181B"
											/>
										</svg>
									</button>
								</div>
							</div>
						</div>
					</div>
				</>
			)}
		</>
	);
};

export default DeleteServiceButton;
